import { render, staticRenderFns } from "./MappingEditorPage.vue?vue&type=template&id=8f151238&scoped=true&"
import script from "./MappingEditorPage.vue?vue&type=script&lang=js&"
export * from "./MappingEditorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f151238",
  null
  
)

export default component.exports